<template>
  <div class="palmInterpretation">
    <div class="left">
      <div class="btn" @click="clickAdd">
        <Icon type="md-cloud-upload" size="20" /> 解读新手相
      </div>
      <div class="list">
        <div
          class="list-item"
          :class="{ active: item === activeItem }"
          v-for="(item, index) in picList"
          :key="index"
          @click="clickItem(item)"
        >
          <div class="i_left">
            <div class="patient-info">
              <span class="name">{{ item.patientName }}</span>
              <span class="sex">{{ item.grenderStr }}</span>
              <span class="age">{{ item.patientAge }}岁</span>
            </div>
            <div class="cont">
              {{ item.sendFlg == 0 ? "解读结果请稍等..." : "点击查看解读" }}
            </div>
            <div class="time">{{ item.crDt }}</div>
          </div>
          <div class="i_right">
            <iImg :src="item.picUrl" type="hand" />
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <add v-if="isAdd" @addSuccess="getData" @close="isAdd = false" />
      <detail v-if="isDetail" :info="activeItem" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import add from "./add.vue";
import detail from "./detail.vue";
export default {
  components: {
    add,
    detail,
  },
  data() {
    return {
      activeItem: {},
      isAdd: false,
      isDetail: false,
      picList: [],
      aidId: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    clickItem(item) {
      this.activeItem = item;
      this.aidId = item.aidId;
      this.isAdd = false;
      this.isDetail = true;
    },
    clickAdd() {
      this.aidId = "";
      this.activeItem = {};
      this.isAdd = true;
      this.isDetail = false;
    },
    getData() {
      return new Promise((resolve, reject) => {
        let obj = {
          pageIndex: 1,
          pageSize: 1000,
          endDate: "",
          startDate: "",
          hospitalCode: "",
          userId: this.userInfo.husDoctorId, //医生编码
        };
        this.api2("getOfferHandPictureList", obj)
          .then((res) => {
            this.picList = res.result.map((i) => {
              i.grenderStr = this.common.gender(i.gender);
              return i;
            });
            resolve(this.picList);
          })
          .catch(reject);
      });
    },
    async refresh() {
      await this.getData();
      if (this.aidId) {
        let item = this.picList.find((i) => i.aidId == this.activeItem.aidId);
        this.activeItem = item || {};
        this.aidId = item.aidId || "";
        if (!this.aidId) {
          this.isDetail = false;
          this.clickAdd();
        }
      }
    },
  },
  mounted() {
    this.getData();
    this.clickAdd();
    this.$bus.on("HandSendMessage", this.refresh);
  },
  beforeDestroy() {
    this.$bus.off("HandSendMessage", this.refresh);
  },
};
</script>

<style lang="scss" scoped>
.palmInterpretation {
  display: flex;
  height: 100%;
  .left {
    width: 400px;
    height: 100%;
    padding-right: 15px;
    margin-right: 15px;
    border-right: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    .btn {
      border-radius: 20px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border: 1px solid #ddd;
      cursor: pointer;
      margin-bottom: 15px;
      box-shadow: 1px 1px 10px #ddd;
    }
    .list {
      height: 100%;
      overflow-y: auto;
      .list-item {
        cursor: pointer;
        padding: 15px;
        border: 1px solid #ddd;
        border-radius: 10px;
        display: flex;
        margin-bottom: 15px;
        &.active {
          background: #ffeef0;
          border-color: #feecee;
        }
        .i_left {
          width: 100%;
          .patient-info {
            font-weight: bold;
            margin-bottom: 5px;
            span {
              margin-right: 10px;
            }
          }
          .cont {
            font-size: 13px;
            margin-bottom: 20px;
          }
          .time {
            font-size: 12px;
          }
        }
        .i_right {
          width: 80px;
          img {
            width: 100%;
            border-radius: 5px;
          }
        }
      }
    }
  }
  .right {
    width: 100%;
    height: 100%;
  }
}
</style>